import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteTermsAndCondition(
    id: string,
): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/terms-and-conditions-templates/${id}`,
        method: "DELETE",
    });
}
